export default  {
  host: 'https://backend.coin-college.com/',
}
